export default {
  demonstrativo: {},
  arquivos: [],
  prestacoescontas: [],
  parecer: null,
}
